import axios from './axios'
import { ElLoading } from 'element-plus'

export function scanCard (scan_str, fromw, callbackFun, callbackErrorFun) {
  const loading = ElLoading.service({
    lock: true,
    text: 'Loading',
    background: 'rgba(0, 0, 0, 0.7)'
  })

  axios.post('/vip_card/scan', {
    scan_str,
    fromw
  }).then(res => {
    if (typeof callbackFun === 'function') {
      callbackFun(res)
    }
  }, error => {
    if (typeof callbackFun === 'function') {
      callbackErrorFun(error)
    }
  })
    .finally(() => {
      loading.close()
    })
}

export function activeCard (param, callbackFun) {
  const loading = ElLoading.service({
    lock: true,
    text: 'Loading',
    background: 'rgba(0, 0, 0, 0.7)'
  })

  axios.post('/vip_card/active', param).then(res => {
    if (typeof callbackFun === 'function') {
      callbackFun(res)
    }
  })
    .finally(() => {
      loading.close()
    })
}

export function getTopupRule (callbackFun) {
  const loading = ElLoading.service({
    lock: true,
    text: 'Loading',
    background: 'rgba(0, 0, 0, 0.7)'
  })

  axios.get('/vip_card/topup_rule').then(res => {
    if (typeof callbackFun === 'function') {
      callbackFun(res)
    }
  })
    .finally(() => {
      loading.close()
    })
}

export function doTopup (param, callbackFun) {
  const loading = ElLoading.service({
    lock: true,
    text: 'Loading',
    background: 'rgba(0, 0, 0, 0.7)'
  })

  axios.post('/vip_card/topup', param).then(res => {
    if (typeof callbackFun === 'function') {
      callbackFun(res)
    }
  })
    .finally(() => {
      loading.close()
    })
}
export function doConsume (param, callbackFun, errorCallbackFun) {
  const loading = ElLoading.service({
    lock: true,
    text: 'Loading',
    background: 'rgba(0, 0, 0, 0.7)'
  })

  axios.post('/vip_card/consume', param).then(res => {
    if (typeof callbackFun === 'function') {
      callbackFun(res)
    }
  }, error => {
    if (typeof errorCallbackFun === 'function') {
      errorCallbackFun(error)
    }
  })
    .finally(() => {
      loading.close()
    })
}

export function getCardOverview (param, callbackFun, errorCallbackFun) {
  const loading = ElLoading.service({
    lock: true,
    text: 'Loading',
    background: 'rgba(0, 0, 0, 0.7)'
  })

  axios.post('/vip_card/overview', param).then(res => {
    if (typeof callbackFun === 'function') {
      callbackFun(res)
    }
  }, error => {
    if (typeof errorCallbackFun === 'function') {
      errorCallbackFun(error)
    }
  })
    .finally(() => {
      loading.close()
    })
}

export function editPwdCard (param, callbackFun) {
  const loading = ElLoading.service({
    lock: true,
    text: 'Loading',
    background: 'rgba(0, 0, 0, 0.7)'
  })

  axios.post('/vip_card/pwd', param).then(res => {
    if (typeof callbackFun === 'function') {
      callbackFun(res)
    }
  })
    .finally(() => {
      loading.close()
    })
}

export function resetPwdCard (param, callbackFun) {
  const loading = ElLoading.service({
    lock: true,
    text: 'Loading',
    background: 'rgba(0, 0, 0, 0.7)'
  })

  axios.post('/vip_card/reset_apply', param).then(res => {
    if (typeof callbackFun === 'function') {
      callbackFun(res)
    }
  })
    .finally(() => {
      loading.close()
    })
}

